export const Team = (props) => {
  return (
    <div id='team' className='text-center'>
      <div className='container'>
        <div className='col-md-8 col-md-offset-2 section-title'>
          <h2>Meet the Team</h2>
          <p>
            The people we have in our business <i>is</i> our business, they are our primary resource and we are proud of each and every one of them.
          </p>
        </div>
        <div id='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4 col-sm-6 team'>
                  <div className='thumbnail'>
                    {' '}
                    <img src={d.img} alt='...' className='team-img' />
                    <div className='caption'>
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                      <p className="bio">{d.bio}</p>
                      {d.profileLink !== undefined ? (
                        <p><br></br><a href={d.profileLink}><img src={d.profileImage} width="200" height="100" /></a></p>
                      ) : (
                        <p></p>
                      )}                      
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
